export default "__VITE_ASSET__b7e19b29__"